module.exports = __webpack_public_path__ + "static/media/hydroponics_systems_net_pots1.eb5e2281.webp";